export default "__VITE_ASSET__C589XKdm__"